export enum FormOfWayType {
  motorway = 'motorway',
  multipleCarriageway = 'multipleCarriageway',
  other = 'other',
  roundabout = 'roundabout',
  singleCarriageway = 'singleCarriageway',
  slipRoad = 'slipRoad',
  trafficSquare = 'trafficSquare'
}

export enum FunctionalRoadClassType {
  FRC0 = 'FRC0',
  FRC1 = 'FRC1',
  FRC2 = 'FRC2',
  FRC3 = 'FRC3',
  FRC4 = 'FRC4',
  FRC5 = 'FRC5',
  FRC6 = 'FRC6',
  FRC7 = 'FRC7'
}

export enum SideOfRoadType {
  onRoadOrUnknown = 'onRoadOrUnknown',
  right = 'right',
  left = 'left',
  both = 'both'
}

export enum OrientationType {
  noOrientationOrUnknown = 'noOrientationOrUnknown',
  withLineDirection = 'withLineDirection',
  againstLineDirection = 'againstLineDirection'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/openlrtypes.ts